import { REQUEST } from 'utils/actionGenerator';
import { takeLatest, takeEvery } from 'redux-saga/effects';
import * as api from './api';
import { fetchEntitySpawn } from 'store/saga';
import * as demandTabActions from './actions';

export function* getDemandDetails(params) {
  const request = api.getDemandDetailsRequest(params);
  yield fetchEntitySpawn(request, demandTabActions.getDemandDetails, params);
}

export function* getConsigners(params) {
  const request = api.getConsignersRequest(params.params);
  yield fetchEntitySpawn(request, demandTabActions.getConsigners, params);
}

export function* getExpenseDetails(params) {
  const request = api.getExpenseDetailsRequest(params);
  yield fetchEntitySpawn(request, demandTabActions.getExpenseDetails, params);
}

export function* getUserDetails(params) {
  const request = api.getUserDetailsRequest(params);
  yield fetchEntitySpawn(request, demandTabActions.getUserDetails, params);
}

export function* getEmailsList(params) {
  const request = api.getEmailsListRequest(params);
  yield fetchEntitySpawn(request, demandTabActions.getEmailsList, params);
}

export function* assignIndent(action) {
  const { dId, payload } = action.payload;
  const request = api.assignIndentRequest(dId, payload);
  yield fetchEntitySpawn(request, demandTabActions.assignIndent, {
    toaster: { successMsg: 'Assignee updated successfully', errorMsg: '' },
    payload,
  });
}

export function* getTransactions(params) {
  const request = api.getTransactionsRequest(params);
  yield fetchEntitySpawn(request, demandTabActions.getTransactions, params);
}

export function* getDemandConfig() {
  const request = api.getFormConfigRequest();
  yield fetchEntitySpawn(request, demandTabActions.getDemandConfig, null);
}
export function* getDemandVehicles(params) {
  const request = api.getVehiclesByDemandIdRequest(params);
  yield fetchEntitySpawn(request, demandTabActions.getDemandVehicles, params);
}

export function* updateDemandDetails(action) {
  const { demandId, payload } = action.payload;
  const request = api.updateDemandDetailsRequest(demandId, payload);
  yield fetchEntitySpawn(request, demandTabActions.updateDemandDetails, {
    toaster: { successMsg: 'Demand details updated successfully', errorMsg: '' },
    payload,
  });
}

export function* updatePtlMetadata(action) {
  const { demandId, payload } = action.payload;
  const request = api.updatePTLMetadataRequest(demandId, payload);
  yield fetchEntitySpawn(request, demandTabActions.updatePtlMetaDetails, {
    toaster: { successMsg: 'PTL Special Request details updated successfully', errorMsg: '' },
    payload,
  });
}

export function* getGstDetails(action) {
  const { demandId } = action.payload;
  const request = api.getGstDetails(demandId);
  yield fetchEntitySpawn(request, demandTabActions.getGstDetails);
}

export function* addExpense(payload) {
  const request = api.addExpenseRequest(payload);
  yield fetchEntitySpawn(request, demandTabActions.addExpense, payload);
}

export function* settleExpense(payload) {
  const request = api.settleExpenseRequest(payload);
  yield fetchEntitySpawn(request, demandTabActions.settleExpense, payload);
}

export function* editExpense(payload) {
  const request = api.editExpenseRequest(payload);
  yield fetchEntitySpawn(request, demandTabActions.editExpense, {
    toaster: { successMsg: 'Expense edited successfully', errorMsg: '' },
    payload,
  });
}

export function* getExpenseTypes(params) {
  const request = api.expenseTypesRequest(params);
  yield fetchEntitySpawn(request, demandTabActions.getExpenseTypes, params);
}

export function* getRemarks(params) {
  const request = api.getRemarksRequest(params);
  yield fetchEntitySpawn(request, demandTabActions.getRemarks, params);
}

export function* getBankDetails(params) {
  const request = api.getBankDetailsRequest(params);
  yield fetchEntitySpawn(request, demandTabActions.getBankDetails, params);
}

export function* getMaterialDetails(params) {
  const request = api.getMaterialDetailsRequest(params);
  yield fetchEntitySpawn(request, demandTabActions.getMaterialDetails, params);
}
export function* getMaterialTypes(params) {
  const request = api.getMaterialTypesRequest(params);
  yield fetchEntitySpawn(request, demandTabActions.getMaterialTypes, params);
}

export function* updateFreightDetails(action) {
  const { demandId, payload } = action.payload;
  const request = api.updateFreightDetailsRequest(demandId, payload);
  yield fetchEntitySpawn(request, demandTabActions.updateFreightDetails, {
    toaster: { successMsg: 'Freight details updated succesfully', errorMsg: '' },
    payload,
  });
}

export function* editTransaction(action) {
  const { transactionId, payload } = action.payload;
  const request = api.editTransactionRequest(transactionId, payload);
  yield fetchEntitySpawn(request, demandTabActions.editTransaction, {
    toaster: { successMsg: 'Transaction edited succesfully', errorMsg: '' },
    payload,
  });
}

export function* createTransaction(payload) {
  const request = api.createTransactionRequest(payload);
  yield fetchEntitySpawn(request, demandTabActions.createTransaction, {
    toaster: { successMsg: 'Transaction created succesfully', errorMsg: '' },
    payload,
  });
}

export function* createMaterialDetails(payload) {
  const request = api.createMaterialDetailsRequest(payload);
  yield fetchEntitySpawn(request, demandTabActions.createMaterialDetails, {
    toaster: { successMsg: 'Material Details updated succesfully', errorMsg: '' },
    payload,
  });
}

export function* deleteExpense(payload) {
  const request = api.deleteExpenseRequest(payload);
  yield fetchEntitySpawn(request, demandTabActions.deleteExpense, {
    toaster: { successMsg: 'Expense deleted succesfully', errorMsg: '' },
    payload,
  });
}

export function* uploadFreight(action) {
  const { demandId, formData } = action.params;
  const request = api.uploadFreightData(demandId, formData);
  yield fetchEntitySpawn(request, demandTabActions.uploadFreight, {
    toaster: { successMsg: 'Freight approval uploaded succesfully', errorMsg: '' },
    isFileUpload: true,
    formData,
  });
}
export function* getPtlMetaData(action) {
  console.log('action - ', action, action.params);
  const { demandId } = action.params;
  const request = api.getPtlMetaDataRequest(demandId);
  yield fetchEntitySpawn(request, demandTabActions.getPtlMetaDetails, {
    toaster: { successMsg: 'Ptl Meta Details fetched Successfully', errorMsg: '' },
  });
}

function* mySaga() {
  yield takeLatest(demandTabActions.GET_DEMAND_DETAILS[REQUEST], getDemandDetails);
  yield takeLatest(demandTabActions.GET_CONSIGNERS[REQUEST], getConsigners);
  yield takeLatest(demandTabActions.GET_USER_DETAILS[REQUEST], getUserDetails);
  yield takeLatest(demandTabActions.GET_TRANSACTIONS[REQUEST], getTransactions);
  yield takeLatest(demandTabActions.GET_DEMAND_CONFIG[REQUEST], getDemandConfig);
  yield takeLatest(demandTabActions.GET_DEMAND_VEHICLES[REQUEST], getDemandVehicles);
  yield takeLatest(demandTabActions.UPDATE_DEMAND_DETAILS[REQUEST], updateDemandDetails);
  yield takeLatest(demandTabActions.UPDATE_FREIGHT_DETAILS[REQUEST], updateFreightDetails);
  yield takeLatest(demandTabActions.UPLOAD_FREIGHT[REQUEST], uploadFreight);
  yield takeLatest(demandTabActions.GET_EXPENSE_DETAILS[REQUEST], getExpenseDetails);
  yield takeLatest(demandTabActions.GET_EXPENSE_TYPES[REQUEST], getExpenseTypes);
  yield takeLatest(demandTabActions.ADD_EXPENSE[REQUEST], addExpense);
  yield takeLatest(demandTabActions.EDIT_EXPENSE[REQUEST], editExpense);
  yield takeLatest(demandTabActions.SETTLE_EXPENSE[REQUEST], settleExpense);
  yield takeLatest(demandTabActions.GET_REMARKS[REQUEST], getRemarks);
  yield takeLatest(demandTabActions.GET_BANK_DETAILS[REQUEST], getBankDetails);
  yield takeLatest(demandTabActions.EDIT_TRANSACTION[REQUEST], editTransaction);
  yield takeLatest(demandTabActions.CREATE_TRANSACTION[REQUEST], createTransaction);
  yield takeEvery(demandTabActions.GET_EMAILS_LIST[REQUEST], getEmailsList);
  yield takeLatest(demandTabActions.ASSIGN_INDENT[REQUEST], assignIndent);
  yield takeLatest(demandTabActions.DELETE_EXPENSE[REQUEST], deleteExpense);
  yield takeLatest(demandTabActions.GET_MATERIAL_DETAILS[REQUEST], getMaterialDetails);
  yield takeLatest(demandTabActions.GET_MATERIAL_TYPES[REQUEST], getMaterialTypes);
  yield takeLatest(demandTabActions.CREATE_MATERIAL_DETAILS[REQUEST], createMaterialDetails);
  yield takeLatest(demandTabActions.GET_PTL_DETAILS[REQUEST], getPtlMetaData);
  yield takeLatest(demandTabActions.UPDATE_PTL_METADATA_DETAILS[REQUEST], updatePtlMetadata);
  yield takeLatest(demandTabActions.GET_GST_DETAILS[REQUEST], getGstDetails);
}
export default mySaga;
